<script setup lang="ts">
import type { RadioGroupItemProps } from "reka-ui"
import type { HTMLAttributes } from "vue"
import { reactiveOmit } from "@vueuse/core"
import {
  RadioGroupIndicator,
  RadioGroupItem,
  useForwardProps,
} from "reka-ui"
import { cn } from "@/lib/utils"

const props = defineProps<RadioGroupItemProps & { class?: HTMLAttributes["class"] }>()

const delegatedProps = reactiveOmit(props, "class")

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <RadioGroupItem
    v-bind="forwardedProps"
    :class="
      cn(
        'peer aspect-square h-5 w-5 shrink-0 rounded-full border-2 border-gray-300 bg-white shadow-sm transition-all duration-200 ease-in-out outline-none',
        'focus:outline-none focus-visible:outline-none',
        'hover:border-blue-400',
        'data-[state=checked]:border-blue-600',
        'disabled:cursor-not-allowed disabled:opacity-50',
        props.class,
      )
    "
  >
    <RadioGroupIndicator class="flex items-center justify-center">
      <span class="h-2.5 w-2.5 rounded-full bg-blue-600" />
    </RadioGroupIndicator>
  </RadioGroupItem>
</template>
